<template>
  <div class="main">
    <div class="leftContent">
      <!-- <router-link to="/hotProduct"><img src="../assets/aa.png" alt="" /></router-link> -->
      <span v-if='picsArr[0]' @click="jumpUrl(0)"><img :src="picsArr[0].pic" alt="" /></span>
    </div>
    <div class="content">
      <div>
        <!-- <router-link to="/newProduct"><img src="../assets/bb.png" alt="" /></router-link> -->
        <span v-if='picsArr[1]' @click="jumpUrl(1)"><img :src="picsArr[1].pic" alt="" /></span>
      </div>
      <div>
        <!-- <router-link to="/newDiscount"><img src="../assets/cc.jpg" alt="" /></router-link> -->
        <span v-if='picsArr[2]' @click="jumpUrl(2)"><img :src="picsArr[2].pic" alt="" /></span>
      </div>
      <div calss="clear"></div>
    </div>
  </div>
</template>

<script>
  import {
    activityPics
  } from '../api/product.js'
  export default {
    name: "List",
    data() {
      return {
        url: "",
        picsArr: [],

      };
    },
    created() {
      // // 模拟数据  start
      // let access_token="bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiI1MjE4MTYiLCJjb21wYW55X3R5cGUiOiIwNSIsInRoaXNfcm9sZV9pZCI6bnVsbCwidXNlcl9uYW1lIjoiMTM3NjA3NzgxMDUiLCJtZW1iZXJfbGV2ZWxfaWQiOi0xLCJmZF9mbGFnIjpmYWxzZSwiZW1wb3dlcl9zdGF0dXMiOjEsInJlYWxfbmFtZSI6IjEzNzYwNzc4MTA1IiwiYXVkaXRfc3RhdHVzIjo0LCJjbGllbnRfaWQiOiIzYWstcGMiLCJkaXNhYmxlX3N0YXR1cyI6MCwidXNlcl90eXBlIjoicGMiLCJyb2xlX2lkIjoiMTEyMzU5ODgxNjczODY3NTIwMiIsInNjb3BlIjpbImFsbCJdLCJvYXV0aF9pZCI6IiIsImlkX3R5cGUiOjIsIm1lbWJlcl9zdG9yZV9pZCI6MTkyNzYyNTcyMTY5MDgzNjk5MywiZXhwIjoxODM4MjU3OTU5LCJqdGkiOiIyYTFmMGJkOC0yODVhLTQxOWItOGNiNS1iODk2ZWRiYTVlNjIiLCJtZW1iZXJfaWQiOjE1ODE1OTkyMDc3MTM3NzE1MjIsInN0b3JlX2lkIjotMSwiYXZhdGFyIjoiIiwiYXV0aG9yaXRpZXMiOlsidXNlciJdLCJyb2xlX25hbWUiOiJ1c2VyIiwibGljZW5zZSI6InBvd2VyZWQgYnkgYmxhZGV4IiwicG9zdF9pZCI6IiIsInVzZXJfaWQiOiIxNTgxNTk5MjA3NjkyODAwMDAyIiwibmlja19uYW1lIjoiMTM3NjA3NzgxMDUiLCJkZXBvc2l0X3N0YXR1cyI6MiwiZGVwdF9pZCI6IiIsImFjY291bnQiOiIxMzc2MDc3ODEwNSIsInN0YXR1cyI6MX0.s1-eEkMA5939QIwq_7rY1Em9Ws7yfTkbvD6ZesACN1U"
      // activityPics(access_token).then(res => {
      //   this.picsArr = res.data.data.activityDetail
      // })
      // // 模拟数据  end
    },
    methods: {
      // js调安卓app
      jumpUrl(urlType) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.url = this.picsArr[urlType].url;
        console.log(window.WebViewJavascriptBridge);
        if (isiOS) {
          // alert(123)
          window.webkit.messageHandlers.jumpList.postMessage(this.url)
        } else {
          this.$bridge.callHandler("jumpList", this.url, res => {
            // alert("获取app响应数据:" + res);
            // console.log(res);
            // this.test = res;
          });
        }
      },
      // 安卓app调js
      getAPPDate() {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {

        } else {
          this.$bridge.registerHandler("getToken", (data, responseCallback) => {
            console.log("安卓app主动调用js方法，传入数据:" + data);
            let access_token = "bearer " + data
            activityPics(access_token).then(res => {
              this.picsArr = res.data.data.activityDetail
            })
            responseCallback(data);
          });
        }
      },
      getToken(token) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          //苹果app调取js方法
          console.log(token)
          let access_token = "bearer " + token
          activityPics(access_token).then(res => {
            this.picsArr = res.data.data.activityDetail
          })
          //  alert("获取app响应数据:" + access_token);
        }
      },
      // getToken()
      // addShoppingCart(goods_id, isRecentExpiration,minOrderNum)
      // jumpGoodsDetail(goods_id)
    },

    //   注册方法
    mounted() {
      // 注册安卓方法
      window.getToken = this.getToken
      this.getAPPDate();
    }

    // H5调用原生APP的js方法
    // function appMessage(str) {
    // str = String(str);
    // var u = navigator.userAgent,
    // app = navigator.appVersion;
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // if (isAndroid) {
    // window.android.goods_sn_main(str);
    // } else if (isiOS) {
    // window.webkit.messageHandlers.AppModel.postMessage({
    // 'str': str
    // });
    // }
    // }
    // 其中goods_sn_main是andriod的方法；
    // AppModel是ios的提供的方法
  };

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    width: calc(100% - 0.2rem);
    display: block;
    height: 1.7rem;
    padding: 0.1rem;
    /* border-radius: 0.1rem; */
    background: #f5f5f5;
    overflow: hidden;
  }

  .main .leftContent {
    height: 100%;
    width: calc(50% - 0.06rem);
    /* width: calc(1.56rem); */
    float: left;
    border-radius: 0.1rem;
    overflow: hidden;
  }

  .main .leftContent span {
    display: block;
    width: 100%;
    height: 100%;
  }

  span img {
    width: 100%;
    height: 100%;
    float: left;
  }

  a {
    display: block;
    width: 100%;
    height: 100%;
  }

  a img {
    width: 100%;
    height: 100%;
    float: left;
  }

  .content {
    height: 100%;
    /* width: 1.56rem; */
    width: calc(50% - 0.06rem);
    float: right;
    overflow: hidden;
  }

  .main .content>div:first-child {
    width: 100%;
    height: 0.82rem;
    margin-bottom: 0.06rem;
    border-radius: 0.1rem;
    overflow: hidden;
  }

  .main .content>div:nth-child(2) {
    width: 100%;
    height: 0.82rem;
    border-radius: 0.1rem;
    overflow: hidden;
  }

  .clear {
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/components/List.vue